import { hot } from 'react-hot-loader/root';
import Component from './messaging-redux';

export default hot(Component);
